import React from "react";
import { Card } from "antd";
import "./AlertCard.css"


 const AlertCardComponent = ({children,show = true}) => {
    
    return (
        show&&
        <div className="alert-container">
      <Card
        className={`card cardNotice`}
      >
        <div>{children}</div>
      </Card>
      </div>
    );
  };

  export default AlertCardComponent
